import ResourcePicker from './ResourcePicker.component';

export default ResourcePicker;
